// extracted by mini-css-extract-plugin
export default {"proMoney":"index_proMoney__EF70d","save_money_content":"index_save_money_content__JF+l6","save_money":"index_save_money__I0gIG","add":"index_add__1Djd3"};